import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import CustomDropdown from "../../../dropdown/CustomDropdown";
import Button from "../../../button";
import { creditRequestFilterData } from "../adminData";

const CreditRequestFilter = ({
  setFilterActive,
  setSelectedSortOption,
  handleApplyClick,
  selectedSortOption,
  loader
}) => {

  return (
    <div className="border border-solid border-[#EBEFF3] rounded-md p-5 w-[255px] bg-white shadow-[0px_14px_18px_0px_rgba(55,77,98,0.14)]">
      <div className="pb-3 border-b border-solid border-[#EBEFF3] sticky mb-5">
        <div className="flex items-center justify-between gap-5">
          <h5 className="text-base font-bold leading-[160%] text-customGray">
            Filter
          </h5>
          <XMarkIcon
            className="w-6 h-6 text-customGray cursor-pointer hover:text-red-500"
            onClick={() => setFilterActive(false)}
          />
        </div>
      </div>
      <div className="mb-5">
        <h6 className="text-sm font-bold leading-[160%] text-[#485868] mb-[14px]">
          Sort by:
        </h6>
        <CustomDropdown
          options={creditRequestFilterData?.map((data) => data.name)}
          classes="px-[14px] md:p-5 border border-solid border-[#EBEFF3] rounded-[10px] h-12 bg-white flex items-center justify-between w-full"
          textClasses="inline-flex w-full items-center text-left gap-x-[10px] text-sm md:text-base font-medium text-customGray"
          rightIconClasses="-mr-1 h-6 w-6 text-customGray font-bold"
          menuClasses="absolute left-0 z-10 mt-5 w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
          setSelectedOption={setSelectedSortOption}
          selectedOption={selectedSortOption}
        />
      </div>
      <Button
        title="Apply"
        classes="bg-primary text-sm font-black leading-[160%] text-white h-[42px] flex items-center justify-center rounded-md capitilize w-full"
        onClick={handleApplyClick}
        buttonLoader={loader}
      />
    </div>
  );
};

export default CreditRequestFilter;
